import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { GlobalAppDataStorageService } from "infra/storage";
import { Controller, useFormContext } from "react-hook-form";

export default function Contact({ data }) {
    const {
        control,
    } = useFormContext();

    const {
        meansOfContact,
    } = data;
    
    const contactFrequencyOptions = GlobalAppDataStorageService.getContactFrequencies();
    const meansOfContactOptions = GlobalAppDataStorageService.getMeansOfContact();
    
    return (
        <Box component="section" sx={{ mb: 4, width: "100%", display: "grid", gap: 2, gridTemplateColumns: "repeat(4, 1fr)" }}>
            <Typography variant="h6" gutterBottom sx={{ gridColumn: "span 4" }}>
                Contact Preferences
            </Typography>
            <Controller
                name="contact.contactFrequency"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="contact.contactFrequency"
                        autoComplete
                        fullWidth
                        options={contactFrequencyOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(event, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Contact Frequency"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="contact.meansOfContact"
                control={control}
                defaultValue={meansOfContact?.data || undefined}
                render={({ field }) => (
                    <Autocomplete
                        id="contact.meansOfContact"
                        autoComplete
                        multiple
                        fullWidth
                        options={meansOfContactOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(_, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Means of Contact"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
        </Box>
    );
}
